/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const resolveViteEnvSources = () => {
  if (typeof import.meta !== 'undefined' && import.meta.env && typeof import.meta.env === 'object') {
    return [import.meta.env];
  }

  return [];
};
